import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import logo from './logo.png';

import css from '../SearchPage.module.css';
import {createSlug} from "../../../util/urlHelpers";
import {NamedLink} from "../../../components";
import {FormattedMessage} from "../../../util/reactIntl";
const REACT_APP_ADMIN_LISTING_ID = process.env.REACT_APP_ADMIN_LISTING_ID;



const Banner = () => {
  const listingTitle = '';

  return (
    <div className={css.bannerHolder}>
      <div className={css.bannerLogoHolder}>
        <img className={css.bannerLogo} src={logo} alt="Athlens away" />
      </div>
      <p className={css.bannerText}>Where You Play, Athlens Follows.</p>
      <NamedLink
        className={css.bannerButton}
        name="ListingPage"
        params={{ id: REACT_APP_ADMIN_LISTING_ID, slug: createSlug(listingTitle) }}
      >
        <FormattedMessage id="SearchPage.bannerButton" />
      </NamedLink>
    </div>
  );
};

const { string } = PropTypes;

Banner.defaultProps = {
  className: null,
  rootClassName: null,
};

Banner.propTypes = {
  className: string,
  rootClassName: string,
};

export default Banner;
